// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AndroidController from "./android_controller"
application.register("android", AndroidController)

import ClockController from "./clock_controller"
application.register("clock", ClockController)

import ContenteditableController from "./contenteditable_controller"
application.register("contenteditable", ContenteditableController)

import DatepickerController from "./datepicker_controller"
application.register("datepicker", DatepickerController)

import DraggableController from "./draggable_controller"
application.register("draggable", DraggableController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditorController from "./editor_controller"
application.register("editor", EditorController)

import FormController from "./form_controller"
application.register("form", FormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import HookController from "./hook_controller"
application.register("hook", HookController)

import MasonryController from "./masonry_controller"
application.register("masonry", MasonryController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import NotificationController from "./notification_controller"
application.register("notification", NotificationController)

import PageController from "./page_controller"
application.register("page", PageController)

import PagesController from "./pages_controller"
application.register("pages", PagesController)

import PublicController from "./public_controller"
application.register("public", PublicController)

import ScreenController from "./screen_controller"
application.register("screen", ScreenController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StepsController from "./steps_controller"
application.register("steps", StepsController)

import TurboController from "./turbo_controller"
application.register("turbo", TurboController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)

import YoutubeController from "./youtube_controller"
application.register("youtube", YoutubeController)
